import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { Link } from "react-router-dom";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { EXTERNAL_LINK, NORMAL_LINK } from "../../constants/constants";

const SitemMap = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const navigateTo = (to, type) => {
    switch (type) {
      case NORMAL_LINK:
        navigate(to);
        break;
      case EXTERNAL_LINK:
        window.open(to, "_blank");
        break;
      case "scroll":
        let element = document.getElementById(to);
        if (element) {
          element?.scrollIntoView({ behavior: "smooth" });
        } else {
          setSearchParams((params) => {
            params.append("scrollTo", to);
          });
          navigate({
            pathname: "/",
            search: createSearchParams(searchParams).toString(),
          });
        }

        break;

      default:
        break;
    }
  };

  return (
    <FullPageContainer>
      <Container>
        <Line>
          <Group>
            <GroupTitle>Platform</GroupTitle>
            <GroupItem as={Link} to="/measure">
              Measure
            </GroupItem>
            <GroupItem as={Link} to="/analyse">
              Analyse
            </GroupItem>
            <GroupItem as={Link} to="/engagement">
              Engagement
            </GroupItem>
            <GroupItem as={Link} to="/messaging">
              Cross-App Messaging
            </GroupItem>
          </Group>

          <Group>
            <GroupTitle>Team</GroupTitle>
            <GroupItem as={Link} to="/marketing">
              Marketing
            </GroupItem>
            <GroupItem as={Link} to="/product">
              Product
            </GroupItem>
            <GroupItem as={Link} to="/data-analytics">
              Data & Analytics
            </GroupItem>
          </Group>

          <Group>
            <GroupTitle>Goal</GroupTitle>
            <GroupItem as={Link} to="/app-growth">
              App Growth
            </GroupItem>
            <GroupItem as={Link} to="/increase-engagement">
              Increase engagement
            </GroupItem>
          </Group>

          <Group>
            <GroupTitle>Platform</GroupTitle>
            <GroupItem as={Link} to="/platform-mobile">
              Mobile
            </GroupItem>
            <GroupItem as={Link} to="/platform-web">
              Web
            </GroupItem>
          </Group>

          <Group>
            <GroupTitle>Why</GroupTitle>
            <GroupItem as={Link} to="/usecase">
              Use cases
            </GroupItem>
            <GroupItem as={Link} to="/privacy">
              Privacy
            </GroupItem>
            <GroupItem as={Link} to="/security">
              Security
            </GroupItem>
            <GroupItem as={Link} to="/sla">
              Service Level Agreements
            </GroupItem>
          </Group>
          <Group>
            <GroupTitle>Resources</GroupTitle>
            <GroupItem as={Link} to="/blog">
              Blog
            </GroupItem>
            <GroupItem
              as={Link}
              to="https://docs.grovs.io/s/docs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Developer Guide
            </GroupItem>

            <GroupItem
              as={Link}
              to="https://docs.grovs.io/s/docs/doc/migration-guides-hoflNvNs9F"
              target="_blank"
              rel="noopener noreferrer"
            >
              Guides
            </GroupItem>
            <GroupItem as={Link} to="/create">
              Free Link generator
            </GroupItem>
            <GroupItem as={Link} to="/migrate-from-fireabse-dynamic-links">
              Migrate from Firebase
            </GroupItem>
          </Group>

          <Group>
            <GroupTitle>Marketing</GroupTitle>
            <GroupItem
              as={Link}
              to="https://docs.grovs.io/s/ba0bb3fe-9516-4b93-b183-a637282554f9"
              target="_blank"
              rel="noopener noreferrer"
            >
              Documentation
            </GroupItem>

            <GroupItem
              as={Link}
              to="https://docs.grovs.io/s/ba0bb3fe-9516-4b93-b183-a637282554f9/doc/how-to-configure-your-project-and-redirect-rules-m1x9AqJLKE"
              target="_blank"
              rel="noopener noreferrer"
            >
              Redirect Setup
            </GroupItem>

            <GroupItem
              as={Link}
              to="https://docs.grovs.io/s/ba0bb3fe-9516-4b93-b183-a637282554f9/doc/how-to-create-a-link-iMhe6BfvSh"
              target="_blank"
              rel="noopener noreferrer"
            >
              Create Links
            </GroupItem>

            <GroupItem
              as={Link}
              target="_blank"
              rel="noopener noreferrer"
              to="https://docs.grovs.io/s/ba0bb3fe-9516-4b93-b183-a637282554f9/doc/ads-platforms-ZMdMRLfx0U"
            >
              Ad Platform Integration
            </GroupItem>
          </Group>
        </Line>
      </Container>
    </FullPageContainer>
  );
};

export default SitemMap;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 100px 80px 100px 80px;
  gap: 80px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 20px;
  }
`;

const Line = styled.section`
  display: flex;
  align-items: start;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;
const GroupTitle = styled.p`
  color: ${lightThemeColors.lightColor};
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 5px;
`;
const GroupItem = styled.p`
  color: rgba(255, 255, 255, 0.52);
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
`;
